import styled from 'styled-components';

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 18px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors?.gray06};
`;

export const StyledTh = styled.th`
  text-align: start;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  vertical-align: bottom;
  background-color: ${({ theme }) =>
    theme.title === 'dark'
      ? theme.colors?.gray02
      : theme.colors?.gray02 || theme.colors?.white01} !important;
  border-top: 1px solid ${({ theme }) => theme.colors?.gray06};
  border-bottom: 2px solid ${({ theme }) => theme.colors?.gray06};
  border-left: 1px solid ${({ theme }) => theme.colors?.gray06};
  border-right: 1px solid ${({ theme }) => theme.colors?.gray06};
  color: ${({ theme }) => theme.colors?.gray04};
`;

export const StyledTd = styled.td`
  text-align: start;
  vertical-align: middle;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid ${({ theme }) => theme.colors?.gray06};
  background-color: ${({ theme }) =>
    theme.title === 'dark'
      ? theme.colors?.gray01
      : theme.colors?.gray01 || theme.colors?.white01} !important;
  border-right: 1px solid ${({ theme }) => theme.colors?.gray06};
  color: ${({ theme }) => theme.colors?.gray04};
`;

export const NotFound = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
